import { MechanicDetailWidget } from 'widgets/mechanicDetailPage/ui/MechanicDetailWidget';

export const MechanicDetailPage = () => <MechanicDetailWidget />;
